import { UploadFileEntityResponse } from '../graphql/generated/graphql';

export const image: UploadFileEntityResponse = {
  data: {
    attributes: {
      url: 'https://i.picsum.photos/id/85/500/300.jpg?hmac=UGrO_uNgIXEV6mTk7PMZmPhLs3NGMhab-l27jAQMItM',
      hash: '123',
      mime: '123',
      name: 'image.jpg',
      provider: 'local',
      size: 1234,
      alternativeText: 'An image',
      caption: 'Caption for the image',
      height: 300,
      width: 500,
      previewUrl:
        'https://i.picsum.photos/id/442/30/30.jpg?hmac=fvKjsshHXyGRx0aKRaskImQCE5F1DSOPzH3xLuqxcFQ',
    },
  },
};
